import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEventCancelled = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Livello_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 18 18",
	style: { enableBackground: "new 0 0 18 18" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill-rule:evenodd;clip-rule:evenodd;}\n"
	}), /* @__PURE__ */ _jsx("path", {
		className: "st0",
		d: "M8.2,12.9v-1.1c0-0.2,0-0.4,0-0.5l2.4-3C11.2,8.1,11.8,8,12.4,8c2.4,0,4.2,1.6,4.2,3.8V13 c0,2.2-1.7,3.9-4.2,3.9C10,16.8,8.2,15.2,8.2,12.9z M11.9,6.9c0.2,0,0.4,0,0.6,0c3.3,0,5.6,2.3,5.6,5.6c0,3.4-2.3,5.6-5.6,5.6 c-3,0-5.3-1.9-5.5-4.9l-4,4.9l-1.1-0.9L15.6,0l1.1,0.9l-1.2,1.5h0.7c0.9,0,1.5,0.5,1.5,1.4V4v2.2h-1.4V3.7h-1.8L11.9,6.9z M11.6,9.9 h1.1v2.5l2,1.8L14,15l-2.4-2.2V9.9z M5.7,0.4v2.1h6.2l-1.1,1.3H5.7v1.8H4.3V3.8H1.8v10.5h0.5l-1.1,1.3c-0.4,0-0.8-0.6-0.8-1.5V4 c0-1,0.6-1.5,1.5-1.5h2.4V0.4C4.3,0.4,5.7,0.4,5.7,0.4z"
	})]
});
export default SvgEventCancelled;
